import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SelectCustomEvent} from '@ionic/angular';
import {TipoRisorsa} from '../../../_models/generated/tipo-risorsa';

const FORMATS_STANDARD = ['MANUALE', 'MAZAK', 'FILE', 'OPCUA', 'MODBUS', 'ZUND', 'DB_MSSQL', 'DB_PGSQL',
  'ETH_DINI', 'PRT_STD', 'PRT_ZEBRA', 'MODULA', 'EIDOS_PRE'];
const FORMATS_SERVIZIO_ESTERNO = ['API'];
// Gli unici protocolli che il WorkerScale sa inizializzare per una bilancia (vedi WorkerScale.InitializeDictionary).
const FORMATS_BILANCE = ['ETH_DINI', 'OPCUA', 'EIDOS_PRE'];

@Component({
  selector: 'app-select-risorse-format',
  templateUrl: './select-risorse-format.component.html',
  styleUrls: ['./select-risorse-format.component.scss'],
  standalone: false
})
export class SelectRisorseFormatComponent {
  @Input() formato = '';
  @Output() formatoChange = new EventEmitter<string>();
  @Input() tipoRisorsa = 0;

  get formats(): string[] {
    switch (this.tipoRisorsa) {
      case TipoRisorsa.SERVIZIO_ESTERNO:
        return FORMATS_SERVIZIO_ESTERNO;
      case TipoRisorsa.BILANCE:
        return FORMATS_BILANCE;
      default:
        return FORMATS_STANDARD;
    }
  }

  selectFormat = (e: SelectCustomEvent) => this.formatoChange.emit(e.target.value);
}
